import groupBy from "lodash/groupBy";

export const sort = (list) => {
  const group = groupBy(list, (item) => item.book_now === true);

  const one = group.true || [];
  const two = group.false || [];

  return one.concat(two);
};

export const age = () => 1000;

export const dataFormat = (item) => {
  const itemShipment = item.shipment_info;
  return {
    age: itemShipment.age,
    auth_required: false,
    biddable: itemShipment.biddable,
    book_now: itemShipment.book_now,
    broker: {
      company: itemShipment.company,
      contact_name: itemShipment.contact,
      dot: item.broker.brokerDot,
      email: item.brokerEmail,
      // fax: item.broker,
      id: item.broker.brokerId,
      mc: itemShipment.mc,
      phone: {
        ext: item.broker.brokerPhoneExt,
        number: item.broker.brokerPhone,
      },
      ext: item.broker.brokerPhoneExt,
      number: item.broker.brokerPhone,
      // transcredit_rating: null,
    },
    // "comments": null,
    created_at: itemShipment.created_at,
    deleted: itemShipment.deleted,
    description: itemShipment.description,
    distance: itemShipment.distance,
    drop_off: {
      address: {
        zip: itemShipment.to_zip,
        city: itemShipment.to_city,
        state: itemShipment.to_state,
      },
      date_local: itemShipment.to_date_local,
      location: itemShipment.to_location,
    },
    equipment: itemShipment.equipment,
    equipment_detailed: itemShipment.equipment_detailed,
    // est_price: null,
    expired: itemShipment.expired,
    featured: itemShipment.featured,
    // height: null,
    id: itemShipment.id,
    length: itemShipment.length,
    load_size: itemShipment.load_size,
    onboarding: itemShipment.onboarding,
    pickup: {
      address: {
        zip: itemShipment.from_zip,
        city: itemShipment.from_city,
        state: itemShipment.from_state,
      },
      date_local: itemShipment.from_date_local,
      // deadhead: null,
      location: itemShipment.from_location,
      price: itemShipment.target_price,
      status: itemShipment.status,
      weight: itemShipment.weight,
      // width: null,
    },
    price:
      itemShipment.target_price && !isNaN(itemShipment.target_price)
        ? parseInt(itemShipment.target_price)
        : 0,
    status: item.status,
    weight: itemShipment.weight,
    // width: null,
  };
};



// WEBPACK FOOTER //
// ./src/misc/booking.js